<form class="login-card" (submit)="submit($event)">
  <h1 class="login-title">
    @if (!forgotPassScreen()) {
      Sign in (internal)
    } @else {
      Forgot password (internal)
    }
  </h1>

  <label for="email">E-mail:</label>
  <input
    id="email"
    type="email"
    [formField]="loginForm.email"
    class="k-input k-input-md login-input"
  />

  @if (!forgotPassScreen()) {
    <label for="password">Password:</label>
    <input
      id="password"
      type="password"
      [formField]="loginForm.password"
      class="k-input k-input-md login-input"
    />
  }

  <a
    href="#"
    (click)="
      forgotPassScreen.set(!forgotPassScreen()); result.set(null); (false)
    "
  >
    @if (!forgotPassScreen()) {
      Forgot password?
    } @else {
      Remembered password?
    }
  </a>

  <button
    kendoButton
    themeColor="primary"
    type="submit"
    [disabled]="!loginForm().valid() || isLoading()"
    class="login-button"
  >
    @if (!forgotPassScreen()) {
      Login
    } @else {
      Send password reset form
    }
  </button>

  <button
    kendoButton
    type="button"
    fillMode="link"
    class="login-link w-100"
    [disabled]="isLoading()"
    (click)="useDifferentProvider.emit()"
  >
    Use a different account provider
  </button>

  @if (result(); as result) {
    @switch (result.type) {
      @case ('result') {
        @switch (result.for) {
          @case ('login') {
            @switch (result.result) {
              @case (loginResultEnum.Fail) {
                <span class="login-error">Invalid E-mail or password</span>
              }
              @case (loginResultEnum.InternalAuthNotEnabled) {
                <span class="login-error">
                  This account does not have internal login enabled.
                </span>
              }
              @case (loginResultEnum.TooManyAttempts) {
                <span class="login-error">
                  There were too many bad login attempts for this account
                  recently, please try again later.
                </span>
              }
              @case (loginResultEnum.NoPassword) {
                <span class="login-error">
                  This account does not have a password set, please reset your
                  password using the "Forgot&nbsp;password" form.
                </span>
              }
            }
          }
          @case ('forgot') {
            @if (result.result) {
              <span class="login-success">
                The password reset form was sent to this E&#8209;mail.
              </span>
            } @else {
              <span class="login-error">
                Could not send password reset form to this E&#8209;mail, please
                check if it is correct or if you have sent too many recently.
              </span>
            }
          }
        }
      }
      @case ('error') {
        <span class="login-error">
          An unknown error happened, please try again later.
        </span>
      }
    }
  }
</form>
